<template>
    <v-container fluid class="text-center row">
      <div class="col-12">Скоро вы будете перенаправлены на страницу...</div>
      <div class="col-12">
        <router-link :to="redirectUrl.route">
          Или нажмите сюда для перехода если это не произошло автоматически
        </router-link>
      </div>
    </v-container>
</template>

<script>
export default {
    data: () => ({
      redirectUrl: null
    }),

    beforeMount() {
      const route = this.$route;
      let relativeUrl = '/' + route.params.relativeUrl;
      if (route.params.pathMatch) {
        relativeUrl += '/' + route.params.pathMatch;
      }

      this.redirectUrl = this.$router.resolve({path: relativeUrl, query: route.query});
    },

    mounted() {
      if (this.redirectUrl?.href) {
        setTimeout(() => {
          window.open(this.redirectUrl.href);
        }, 1500);
      } else {
        this.$router.push({name: "Cabinet"});
      }
    }
}
</script>
